export default {
  title: 'Инструменты поддержки принятия решений',
  description: 'Estimator24 помогает покупателям, инвесторам и агентствам принимать обоснованные решения на основе данных и ИИ.',
  features: {
    evaluation: 'Оценка недвижимости в один клик',
    forecast: 'Прогнозы цен с помощью нейросетей',
    analytics: 'Анализ рынка по регионам и районам',
    tools: 'Инструменты сравнения и фильтрации'
  }
}